module.exports = __webpack_public_path__ + "media/images/pc/page_common/banner/banner_nyaccessory-7d55fbe5512236a1b25ff2ad27fd5b15.png";